// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InboundEmails_root__6Lq\\+r {
  padding: 20px 20px;
  height: calc(100vh - 188px);
  overflow-y: scroll;
}

.InboundEmails_list_container__Y8uEW {
  position: fixed;
  left: 210px;
  top: 90px;
  width: 290px;
  background-color: var(--color-bg-caselist);
  overflow: scroll;
  padding: 10px;
  padding-top: 10px;
  overflow-x: hidden;
  height: calc(100vh - 148px);
}

.InboundEmails_list_item_container__7-ny0 {
  margin: 5px;
  padding: 10px;
  max-height: 90px;
  min-height: 40px;
  background-color: var(--color-bg-caselist-item);
  border: 1px solid var(--color-theme-bright-gray);
  cursor: pointer;
}

.InboundEmails_list_item_container_selected__rjzJG {
  margin: 5px;
  padding: 10px;
  max-height: 90px;
  min-height: 40px;
  background-color: var(--color-bg-caselist-item-hover);
  border: 1px solid var(--color-bg-caselist-item-hover);
  cursor: pointer;
  box-shadow: 2px 2px 3px var(--color-theme-cloud);
}

.InboundEmails_list_item_container__7-ny0:hover {
  background-color: var(--color-bg-caselist-item-hover);
  border: 1px solid var(--color-bg-caselist-item-hover);
}

.InboundEmails_lower_row_gray__1ZCOB {
  color: #bbbbbb;
}

.InboundEmails_unread_marker__PPhwI {
  border-radius: 10px;
  width: 7px;
  height: 7px;
  background-color: royalblue;
  float: right;
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/InboundEmails/InboundEmails.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,qDAAqD;EACrD,qDAAqD;EACrD,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,YAAY;AACd","sourcesContent":[".root {\n  padding: 20px 20px;\n  height: calc(100vh - 188px);\n  overflow-y: scroll;\n}\n\n.list_container {\n  position: fixed;\n  left: 210px;\n  top: 90px;\n  width: 290px;\n  background-color: var(--color-bg-caselist);\n  overflow: scroll;\n  padding: 10px;\n  padding-top: 10px;\n  overflow-x: hidden;\n  height: calc(100vh - 148px);\n}\n\n.list_item_container {\n  margin: 5px;\n  padding: 10px;\n  max-height: 90px;\n  min-height: 40px;\n  background-color: var(--color-bg-caselist-item);\n  border: 1px solid var(--color-theme-bright-gray);\n  cursor: pointer;\n}\n\n.list_item_container_selected {\n  margin: 5px;\n  padding: 10px;\n  max-height: 90px;\n  min-height: 40px;\n  background-color: var(--color-bg-caselist-item-hover);\n  border: 1px solid var(--color-bg-caselist-item-hover);\n  cursor: pointer;\n  box-shadow: 2px 2px 3px var(--color-theme-cloud);\n}\n\n.list_item_container:hover {\n  background-color: var(--color-bg-caselist-item-hover);\n  border: 1px solid var(--color-bg-caselist-item-hover);\n}\n\n.lower_row_gray {\n  color: #bbbbbb;\n}\n\n.unread_marker {\n  border-radius: 10px;\n  width: 7px;\n  height: 7px;\n  background-color: royalblue;\n  float: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `InboundEmails_root__6Lq+r`,
	"list_container": `InboundEmails_list_container__Y8uEW`,
	"list_item_container": `InboundEmails_list_item_container__7-ny0`,
	"list_item_container_selected": `InboundEmails_list_item_container_selected__rjzJG`,
	"lower_row_gray": `InboundEmails_lower_row_gray__1ZCOB`,
	"unread_marker": `InboundEmails_unread_marker__PPhwI`
};
export default ___CSS_LOADER_EXPORT___;
